/**
 * Public page paths - used in API interceptor to prevent redirect on 401 errors
 */
export const PUBLIC_PATHS = [
  '/',
  '/login',
  '/register',
  '/forgot-password',
  '/reset-password',
  '/auth/callback',
  '/app/magic-login',
  '/magic-login',
  '/complete-profile',
  '/terms-and-conditions',
  '/privacy-policy',
  '/permission-denied',
  '/referral-action',
  '/explore',
  '/v1'
] as const

/**
 * Public page names - used in router guard for authentication check
 */
export const PUBLIC_PAGE_NAMES = [
  'Landing',
  'Login',
  'PasswordLogin',
  'Register',
  'ForgotPassword',
  'ResetPassword',
  'AuthCallback',
  'MagicLogin',
  'CompleteProfile',
  'NotFound',
  'PermissionDenied',
  'Terms and conditions',
  'Privacy policy',
  'ReferralActionResult',
  'ReferralActionProvideLink',
  'Landing V1',
  'Public Jobs',
  'Public Job Details'
] as const
